import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class HeroAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.heroSection = document.querySelector('#hero-section');
    this.heroTitle = this.heroSection.querySelector('.hero__title');
  }

  show() {
    window.addEventListener('preloaderComplete', () => {
      setTimeout(() => {
        this.videoBg.classList.remove('hero-video--start')
      }, 100)
    })
  }

  onLeave() {
    window.dispatchEvent(this.transitionStart)
    this.videoBg.classList.add('bg-img--darken')
    this.videoBgImg.classList.add('bg-img--zoomed-max')
    this.heroTitle.classList.add('hero__title--hidden')
  }

  onVisit() {
    this.showVideo()
    this.videoBg.classList.remove('bg-img--darken')
    this.videoBgImg.classList.remove('bg-img--zoomed-max')
    setTimeout(() => {
      this.heroTitle.classList.remove('hero__title--hidden')
    }, this.ANIM_DUR + this.EXTRA_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }
}
